import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { rotationsInfoKeys } from '@/hooks/tie-breaker/rotationsInfoKeys';
import { deleteAllTieBreakerRotations } from '@/services/actions/tie-breaker/rotations';

export const useDeleteAllTieBreakerRotationsMutation = (tieBreakerMatchUuid: string) => {
	const queryClient = useQueryClient();

	const deleteAllRotations = useMutation({
		mutationFn: async (team: '1' | '2') => {
			const result = await deleteAllTieBreakerRotations({ matchId: tieBreakerMatchUuid, team });
			if (result.error) throw new Error(result.error);
			return result.data;
		},
		onSuccess: () => {
			toast.success('Tiebreaker rotations deleted successfully.');
			queryClient.invalidateQueries({
				queryKey: rotationsInfoKeys.rotationsInfo(tieBreakerMatchUuid)
			});
		},
		onError: () => {
			toast.error('Failed to delete tiebreaker rotations. Please try again.');
		}
	});

	return {
		deleteAllRotations,
		isDeleting: deleteAllRotations.isPending
	};
};
